module.exports = __webpack_public_path__ + "img/Hunter.bc33158f.png";